import { getLocale } from "@lana-commerce/core/translateLocale";
import { graphql, useStaticQuery } from "gatsby";
import { nonNull } from "@lana-commerce/core/nonNull";

import { ShopData } from "./def";

export function useShopData() {
  const locale = getLocale();
  const data = useStaticQuery(graphql`
    query ShopData {
      rawJsonData(id: { eq: "shop_data" }) {
        value
      }
    }
  `);
  const shopDatas = data.rawJsonData.value as ShopData[];
  return nonNull(
    shopDatas.find((d) => d.locale === locale),
    `shop data for "${locale}" locale`
  );
}
